import apiClient from "@/axiosConfig";
import { useUxStore } from "@/stores/uxStore";

const getUxStore = () => useUxStore();


export default {
  async getRequests({ status = null, search = null, page = 1, pageSize = 50, hideClosed = false } = {}) {
    try {
      getUxStore().startLoading();
      const params = { page, pageSize };
      if (status) params.status = status;
      if (search) params.search = search;
      if (hideClosed) params.hideClosed = true;
      return await apiClient.get("/provisioning/requests", { params });
    } catch (error) {
      console.error("Error in ProvisioningService.getRequests:", error);
      getUxStore().setError("Fehler beim Laden der Provisionierungsanfragen.");
      throw error;
    } finally {
      getUxStore().stopLoading();
    }
  },

  async getRequest(id) {
    try {
      getUxStore().startLoading();
      return await apiClient.get(`/provisioning/requests/${id}`);
    } catch (error) {
      console.error("Error in ProvisioningService.getRequest:", error);
      getUxStore().setError("Fehler beim Laden der Provisionierungsanfrage.");
      throw error;
    } finally {
      getUxStore().stopLoading();
    }
  },

  async createRequest(payload) {
    try {
      getUxStore().startLoading();
      return await apiClient.post("/provisioning/requests", payload);
    } catch (error) {
      console.error("Error in ProvisioningService.createRequest:", error);
      throw error;
    } finally {
      getUxStore().stopLoading();
    }
  },

  async updateRequest(id, payload) {
    try {
      getUxStore().startLoading();
      return await apiClient.put(`/provisioning/requests/${id}`, payload);
    } catch (error) {
      console.error("Error in ProvisioningService.updateRequest:", error);
      throw error;
    } finally {
      getUxStore().stopLoading();
    }
  },
  async approveRequest(id, notes = null) {
    try {
      getUxStore().startLoading();
      return await apiClient.post(`/provisioning/requests/${id}/approve`, { notes });
    } catch (error) {
      console.error("Error in ProvisioningService.approveRequest:", error);
      getUxStore().setError("Fehler beim Freigeben der Anfrage.");
      throw error;
    } finally {
      getUxStore().stopLoading();
    }
  },

  async cancelRequest(id, reason) {
    try {
      getUxStore().startLoading();
      return await apiClient.post(`/provisioning/requests/${id}/cancel`, { reason });
    } catch (error) {
      console.error("Error in ProvisioningService.cancelRequest:", error);
      getUxStore().setError("Fehler beim Stornieren der Anfrage.");
      throw error;
    } finally {
      getUxStore().stopLoading();
    }
  },

  async executeSharedSaas(id) {
    try {
      getUxStore().startLoading();
      return await apiClient.post(`/provisioning/requests/${id}/execute-shared-saas`);
    } catch (error) {
      console.error("Error in ProvisioningService.executeSharedSaas:", error);
      getUxStore().setError("Fehler beim Ausführen der Shared-SaaS-Provisionierung.");
      throw error;
    } finally {
      getUxStore().stopLoading();
    }
  },

  async retry(id) {
    try {
      getUxStore().startLoading();
      return await apiClient.post(`/provisioning/requests/${id}/retry`);
    } catch (error) {
      console.error("Error in ProvisioningService.retry:", error);
      getUxStore().setError("Fehler beim Wiederholen der Provisionierung.");
      throw error;
    } finally {
      getUxStore().stopLoading();
    }
  },

  async updateOnboardingTask(taskId, payload) {
    try {
      getUxStore().startLoading();
      return await apiClient.put(`/provisioning/onboarding-tasks/${taskId}`, payload);
    } catch (error) {
      console.error("Error in ProvisioningService.updateOnboardingTask:", error);
      getUxStore().setError("Fehler beim Aktualisieren der Onboarding-Aufgabe.");
      throw error;
    } finally {
      getUxStore().stopLoading();
    }
  },
};
